import { render } from "./buildingComponent.vue?vue&type=template&id=2c73b4c3&scoped=true"
import script from "./buildingComponent.vue?vue&type=script&lang=js"
export * from "./buildingComponent.vue?vue&type=script&lang=js"

import "./buildingComponent.vue?vue&type=style&index=0&id=2c73b4c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c73b4c3"]])

export default __exports__